import gql from 'graphql-tag';

export const getExternalContactListHistories = gql`
  query getExternalContactListHistories($id: ID!) {
    getExternalContactListHistories(id: $id) {
      updater
      updatedAt
    }
  }
`;
